import { rotinasPCE } from "./rotinas";

/** Catálogo das rotinas PCE disponíveis no coletor WEB. */
export default function useRotinasPCE() {
	return rotinasPCE;
}
